export const BREAKDOWN_GROUP_BY_OPTIONS = ['category', 'group', 'merchant'] as const;

export type BreakdownGroupKey = (typeof BREAKDOWN_GROUP_BY_OPTIONS)[number];

export const VISIBLE_GROUP_BY_OPTIONS = ['Category', 'Group', 'Merchant'];
